import { CheckCircleOutlined, GlobalOutlined } from "@ant-design/icons";
import type { CardProps } from "antd";
import { Button, Card, Descriptions, Tag } from "antd";
import type { FC } from "react";
import { useNavigate } from "react-router";

import type { DataGroupInfoDto } from "../types/Dashboard";

interface DataGroupInfoCardProps extends CardProps {
    dataGroupInfo: DataGroupInfoDto;
}

/**
 * DataGroupInfoCard - Displays data group information in sidebar
 */
export const DataGroupInfoCard: FC<DataGroupInfoCardProps> = ({ dataGroupInfo, ...cardProps }) => {
    const navigate = useNavigate();

    const getStatusColor = (status: string): string => {
        const statusMap: Record<string, string> = {
            ACTIVE: "green",
            INACTIVE: "red",
            PENDING: "orange",
        };
        return statusMap[status.toUpperCase()] || "default";
    };

    const handleChange = (record: DataGroupInfoDto) => {
        navigate(`/data-groups/edit/${record.id}`);
    };

    return (
        <Card
            title={<span>Data Group</span>}
            extra={
                <Button size="small" onClick={() => handleChange(dataGroupInfo)}>
                    Change
                </Button>
            }
            size="small"
            {...cardProps}
            style={{ backgroundColor: "#FFFFFF", ...cardProps.style }}
        >
            <Descriptions column={1} size="small">
                <Descriptions.Item label="Name">
                    <strong>{dataGroupInfo.name}</strong>
                </Descriptions.Item>
                <Descriptions.Item label="Status">
                    <Tag color={getStatusColor(dataGroupInfo.status)} icon={<CheckCircleOutlined />}>
                        {dataGroupInfo.status}
                    </Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Code">
                    <span>{dataGroupInfo.code}</span>
                </Descriptions.Item>
                <Descriptions.Item label="Timezone">
                    <span>
                        <GlobalOutlined style={{ marginRight: 4 }} />
                        {dataGroupInfo.timeZone}
                    </span>
                </Descriptions.Item>
                <Descriptions.Item label="TID Template">{dataGroupInfo.tidTemplate || "N/A"}</Descriptions.Item>
            </Descriptions>
        </Card>
    );
};
